export default {
  '--bottom-navigation-background-color': '#272727',
  '--bottom-navigation-border-color': '#444'
};